<template>
  <div id="admin-container" class="wrapper">
    <div class="inner-wrap">
      <h2>Twitter Campaigns</h2>
      <div class="list-wrap">
        <div class="pure-form pure-form-stacked">
          <h4>Create campaign</h4>
          <label>Grape List</label>
          <select name="list_select" id="list_select" v-on:change="listChange()">
            <option v-for="list in lists" :value="list.id">{{list.name}}</option>
          </select>
          <label>Start schedule time</label>
          <datetime type="date" class="theme-grapevine" v-model="datetime"></datetime>
          <div class="pure-button" v-on:click="createTwitterCampaign">Create New Campaign</div>
        </div>
        <div id="grape-capture-wrap">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* global $, algoliasearch */
  import firebase from 'firebase'
  import db from '../firebaseInit'
  import Request from 'superagent'
  import { Datetime } from 'vue-datetime';
  import 'vue-datetime/dist/vue-datetime.css'
  import html2canvas from 'html2canvas'

  export default {
    data: function () {
      return {
        root: 'grapes-table',
        currentUserID: null,
        userLoggedIn: false,
        userIsAdmin: this.$globals.userRole == 'admin',
        currentList: null,
        lists: [],
        listGrapeIDs: [],
        mailchimpLists: [],
        localCampaigns: [],
        datetime: null,
        grapeIDs: [],
        isAddingCampaign: false,
        segment1aday: '53021',
        segment3aday: '53025',
        segment7aweek: '53029',
        mailchimpListID: null,
        mailchimpListName: null,
        grapeListID: null,
        grapeListName: null,
        datetime: null,
        weekdayTimeArray: [
          '09',
          '10',
          '11',
          '12',
          '13',
          '14',
          '15',
          '16',
          '17',
          '18'
        ],
        weekendTimeArray: [
          '09',
          '10',
          '11',
          '12',
          '13'
        ]
      }
    },
    name: 'twitterAdmin',
    components: {
      datetime: Datetime
    },
    created () {
      let vm = this
      vm.$globals.isAdmin = true
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          vm.currentUserID = user.uid
          vm.getLists()
          //vm.getMailchimpLists()
          //vm.getLocalCampaigns()
        }
      })
    },
    methods: {
      showLoading () {
        $('body').addClass('pace-running')
        $('.pace').addClass('pace-active')
      },
      hideLoading () {
        $('body').removeClass('pace-running')
        $('.pace').removeClass('pace-active')
      },
      addUTCDays: function (date, days) {
        var d = new Date(date)
        var d2 = d.setDate(d.getDate() + days)
        var returnDate = new Date(d2)
        return returnDate
      },
      getMailchimpLists () {
        let vm = this
        console.log('doing request')
        const req = Request
        .get('https://us-central1-grapevine-dc853.cloudfunctions.net/MailchimpListLists')
        .then(function(res) {
          var obj = JSON.parse(res.body.text)
          console.log(res)
          console.log(obj)
          for (let i = 0; i < obj.lists.length; i++) {
            let data = obj.lists[i]
            vm.mailchimpLists.push({
              id: data.id,
              name: data.name
            }) 
          }
        })
      },
      createTwitterCampaign () {
        console.log('createTwitterCampaign')
        let vm = this

        $('#grape-capture-wrap').empty()

        // get start date
        var startDate = vm.datetime
        var date = new Date(startDate)
        // vm.createTweet(date, 'da5b3783-e677-4899-acce-e0ec80febb7c')

        // track count
        var c = 0

        // loop mon-thurs
        for (var d = 0; d < 4; d++) {
          for (var i = 0; i < vm.weekdayTimeArray.length; i++) {
            date.setHours(vm.weekdayTimeArray[i])
            vm.createTweet(date, vm.listGrapeIDs[c])
            c++
          }
          date = vm.addUTCDays(date, 1)
        }

        // loop fri-sat
        for (var e = 0; e < 2; e++) {
          for (var j = 0; j < vm.weekendTimeArray.length; j++) {
            date.setHours(vm.weekendTimeArray[j])
            vm.createTweet(date, vm.listGrapeIDs[c])
            c++
          }
          date = vm.addUTCDays(date, 1)
        }

        // update grape mailchimp count
        const req = Request
        .post('https://us-central1-grapevine-dc853.cloudfunctions.net/grapesIncreaseTwitterCampaignCount')
        .query({ grapeIDs: vm.listGrapeIDs })
        .then(function() {
          console.log('updated grape twitter count')
        })

      },
      createTweet: function (datetime, grapeID) {
        let vm = this
        if (grapeID) {
          var tweetText = ''
          datetime = datetime.toISOString()
          datetime = datetime.replace('00.000Z', '00Z')
          console.log('datetime: ' + datetime + ', grapeID: ' + grapeID)
          if (grapeID) {
            db.collection('grapes').where('id', '==', grapeID).get().then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                var grapeData = doc.data()
                grapeData.docID = doc.id
                vm.createShareImage(grapeData, datetime)
                // if (grapeData.shareImage && grapeData.shareImage.length > 0) {
                //   vm.uploadMedia(grapeData, datetime)
                // } else {
                //   vm.createShareImage(grapeData, datetime)                  
                // }
              })
            })
          }
        }
      },
      createShareImage: function (grapeData, datetime) {
        let vm = this
        var $share_html = ''
        var description = grapeData.grapeContent
        if (description.indexOf('<p>') < 0) {
          var lines = description.split("<br>")
          description = '<p>' + lines.join("</p><p>") + '</p>'
        }
        description = vm.replaceGrapeTextSymbols(description)

        $share_html += '<div id="grape-' + grapeData.id + '" class="grape-capture-outer">'
        $share_html += '<div class="grape-capture">'
        $share_html += '<h4 class="grape-author">' + grapeData.sourceAuthor + '</h4>'
        $share_html += '<h3 class="grape-title">' + grapeData.grapeTitle + '</h3>'
        $share_html += '<span class="grape-source">' + grapeData.grapeSource + '</span>'
        $share_html += '<div class="grape-content-wrap">'
        $share_html += '<div class="grape-content-preview-overlay"></div>'
        $share_html += '<div class="grape-content">' + description + '</div>'
        $share_html += '</div>'
        $share_html += '<div class="grapevine-link">'
        $share_html += '<a href="https://atgrapevine.com" target="_blank">atgrapevine.com</a>'
        $share_html += '</div>'
        $share_html += '</div>'
        $share_html += '</div>'
        $('#grape-capture-wrap').append($share_html)
        html2canvas(document.querySelector('#grape-' + grapeData.id), {allowTaint: false}).then(canvas => {
          var data = canvas.toDataURL()
          data = data.replace('data:image/png;base64,', '')
          var grapeRef = db.collection('grapes').doc(grapeData.docID)
          grapeData.shareImage = data
          grapeRef.update({
            shareImage: data
          }).then(function (docRef) {
            console.log('Document ' + grapeData.docID + ' successfully updated with share image!')
            vm.uploadMedia(grapeData, datetime)
          })
        })
      },
      getCanvasBlob (canvas) {
        return new Promise(function (resolve, reject) {
          canvas.toBlob(function (blob) {
            resolve(blob)
          }, 'image/jpeg', 0.95)
        })
      },
      uploadMedia: function (grapeData, datetime) {
        let vm = this
        const req = Request
        .post('https://us-central1-grapevine-dc853.cloudfunctions.net/TwitterUploadMedia')
        .query({ grapeID: grapeData.id })
        .then(function(res) {
            var data = JSON.parse(res.text)
            if (res.status === 200) {
              let media_id = data.media_id_string
              vm.scheduleTweet(grapeData, datetime, media_id)
            }
        });
      },
      scheduleTweet: function (grapeData, datetime, media_id) {
        var link = 'https://atgrapevine.com/view-grape/' + grapeData.id
        var title = grapeData.grapeTitle
        var source = "'" + grapeData.grapeSource + "'"
        var tweetText =  grapeData.sourceAuthor + ' on ' + title + ' from ' + source + ' (' + grapeData.grapeOriginalPublishYear + '). ' + link
        console.log(tweetText)
        let vm = this
        const req = Request
        .post('https://us-central1-grapevine-dc853.cloudfunctions.net/TwitterScheduleTweet')
        .query({ tweetText: tweetText })
        .query({ datetime:  datetime })
        .query({ media_id:  media_id })
        .then(function(res) {
            console.log(res);
            var data = JSON.parse(res.text)
        });
      },
      createCampaignContent: function (campaignID, grapeIDs, datetime) {
        let vm = this
        var content = ''
        var grapesProcessed = 0
        console.log(grapeIDs)
        grapeIDs.forEach(grapeID => {
          db.collection('grapes').where('id', '==', grapeID).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              var grapeData = doc.data()
              content += '<div class="grape">' + grapeData.grapeTitle + '</div>'
              grapesProcessed++
              if (grapesProcessed === grapeIDs.length) {
                vm.setCampaignContent(campaignID, content, datetime)
              }
            })
          })
        })
      },
      setCampaignContent: function (campaignID, content, datetime) {
        let vm = this
        const req = Request
        .post('https://us-central1-grapevine-dc853.cloudfunctions.net/MailchimpSetCampaignContent')
        .query({ campaignID: campaignID })
        .query({ content: content })
        .then(function(res) {
            var data = JSON.parse(res.body.text)
            console.log(data);
            vm.scheduleCampaign(campaignID, datetime)
        });
      },
      createLocalCampaign: function (campaignData) {
        let vm = this
        vm.isAddingCampaign = true
        campaignData.createdTimestamp = firebase.firestore.FieldValue.serverTimestamp()
        db.collection('mailchimpCampaigns').add(campaignData).then(function (docRef) {
          console.log('Document written with ID: ', docRef.id)
          setTimeout(function () {
            vm.isAddingCampaign = false
          }, 500)
        })
      },
      getCampaignDetails: function (campaignData) {
        let vm = this
        const req = Request
        .get('https://us-central1-grapevine-dc853.cloudfunctions.net/MailchimpGetCampaignDetails')
        .query({ campaignID: campaignData.mailchimpCampaignID })
        .then(function(res) {
          var data = JSON.parse(res.body.text)
          console.log(data)
          if (data.status != '404') {
            campaignData.mailchimpCampaignStatus = data.status
          } else {
            campaignData.mailchimpCampaignStatus = 'not found'
            return
          }
          if (data.send_time) {
            campaignData.mailchimpCampaignSendTime = data.send_time
          }
          vm.localCampaigns.push(campaignData)
          vm.campaignsSort()
        })
      },
      scheduleCampaign: function (campaignID, datetime) {
        let vm = this
        datetime = datetime.slice(0, -7) + '00+00:00'
        vm.setCampaignSchedule(campaignID, datetime)
      },
      setCampaignSchedule: function (campaignID, datetime) {
        console.log('campaignID: ' + campaignID + ', datetime: ' + datetime)
        const req = Request        
        .post('https://us-central1-grapevine-dc853.cloudfunctions.net/MailchimpSetCampaignSchedule')
        .query({ campaignID: campaignID })
        .query({ scheduleTime: datetime }) // Must look like this format: 2019-02-04T19:15:00+00:00
        .then(function(res) {
            var text = res.body.text
            if (text === '') {

            } else {
              var data = JSON.parse(res.body.text)
              if (data.status == 400) {
                alert(data.detail)
              }
            }
         });
      },
      getLists: function () {
        let vm = this
        var listsRef = db.collection('lists')
        listsRef.get().then((querySnapshot) => {
          console.log('created query: ' + querySnapshot.docs.length)
          querySnapshot.forEach((doc) => {
            var listData = doc.data()
            listData.id = doc.id
            if (!vm.checkPresentInArray(vm.lists, listData.id, true)) {          
              vm.lists.push(listData)
            }
          })
          setTimeout(function () {
            vm.hideLoading()
            vm.listChange()
          }, 1000)
        })
      },
      listChange: function () {
        let vm = this
        let $listID = $('#list_select').val()
        console.log('list changed: ' + $listID)
        vm.listGrapeIDs = []
        var listRef = db.collection('lists').doc($listID)
        listRef.get().then(function (doc) {
          console.log(doc.id, ' => ', doc.data())
          vm.listGrapeIDs = doc.data().grapes
        })
      },
      getLocalCampaigns: function () {
        let vm = this
        var campaignsRef = db.collection('mailchimpCampaigns')
        campaignsRef.get().then((querySnapshot) => {
          console.log('created query: ' + querySnapshot.docs.length)
          querySnapshot.forEach((doc) => {
            var campaignData = doc.data()
            campaignData.id = doc.id
            if (!vm.checkPresentInArray(vm.localCampaigns, campaignData.id, true)) {
              vm.getCampaignDetails(campaignData)
            }
          })
          setTimeout(function () {
            vm.hideLoading()
          }, 1000)
        })
      },
      campaignsSort: function () {
        let vm = this
        vm.localCampaigns.sort(function (a, b) {
          var textA = a.mailchimpCampaignSubject.toUpperCase()
          var textB = b.mailchimpCampaignSubject.toUpperCase()
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
      },
      checkPresentInArray: function (inArr, ID, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].id === ID) {
            return (exists === true) ? true : inArr[i]
          }
        }
      },
      replaceGrapeTextSymbols (text) {
        //text = text.replace(/-\s/g, '')
        //text = text.replace(/—/g, '&#8211;')
        text = text.replace(/--/g, '–')
        text = text.replace(/ - /g, '&#8211;')
        text = text.replace(/ -&nbsp;/g, '&#8211;')
        text = text.replace(/ {2}- {2}/g, ' – ')
        text = text.replace(/ {2}– /g, ' – ')
        text = text.replace(/ – {2}/g, ' – ')
        //text = text.replace(/([a-zA-Z0-9])\-([a-zA-Z0-9])/g, '$1 &#8211; $2') /* Ensure spaces between in-word hyphen */
        text = text.replace(/([a-zA-Z0-9])—([a-zA-Z0-9])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/([a-zA-Z0-9])\—([a-zA-Z0-9])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/([a-zA-Z0-9])—([a-zA-Z0-9])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/([a-zA-Z0-9])–([a-zA-Z0-9])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/([a-zA-Z0-9])&#8211;([a-zA-Z0-9])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/([a-zA-Z0-9])&#8212;([a-zA-Z0-9])/g, '$1 &#8211; $2') /* Ensure space after full stop */
        text = text.replace(/\.([a-zA-Z0-9])/g, '. $1') /* Ensure space after full stop */
        text = text.replace(/\!([a-zA-Z0-9])/g, '! $1') /* Ensure space after exclamation mark */
        text = text.replace(/\?([a-zA-Z0-9])/g, '? $1') /* Ensure space after question mark */
        text = text.replace(/ &#8211;([a-zA-Z0-9])/g, ' &#8211; $1') /* Ensure space after — */
        text = text.replace(/&#8211; ([a-zA-Z0-9])/g, ' &#8211; $1') /* Ensure space before — */
        text = text.replace(/— ([a-zA-Z0-9])/g, ' &#8211; $1') /* Ensure space before — */
        text = text.replace(/ —([a-zA-Z0-9])/g, ' &#8211; $1') /* Ensure space before — */
        text = text.replace(/– ([a-zA-Z0-9])/g, ' &#8211; $1') /* Ensure space before — */
        text = text.replace(/ –([a-zA-Z0-9])/g, ' &#8211; $1') /* Ensure space before — */
        text = text.replace(/\. \" /g, '.\" ') /* Remove space between full stop and quotemark */
        text = text.replace(/\? \" /g, '?\" ') /* Remove space between question mark and quotemark */
        text = text.replace(/\! \" /g, '!\" ') /* Remove space between exclamation mark and quotemark */
        text = text.replace(/\. \' /g, '.\' ') /* Remove space between full stop and quotemark */
        text = text.replace(/\? \' /g, '?\' ') /* Remove space between question mark and quotemark */
        text = text.replace(/\! \' /g, '!\' ') /* Remove space between exclamation mark and quotemark */
        // text = text.replace(/.\s*([a-z])/g, function(d,e) { return '. ' + e.toUpperCase() }) /* Ensure capital letter after full stop */
        text = text.replace(/ ofa /g, ' of a ') /* Change 'ofa' to 'of a' */
        text = text.replace(/ ofthe /g, ' of the ') /* Change 'ofa' to 'of a' */
        text = text.replace(/”/g, '\'') /* Change ” to ' */
        text = text.replace(/ {2}/g, ' ') /* Change double spacing to single */
        text = text.replace(/\+>/g, '+ >')
        text = text.replace(/\.{\+}/g, '. <i class="fal fa-genderless"></i>')
        text = text.replace(/\(\+\)/g, '<i class="fal fa-genderless"></i>')
        text = text.replace(/\{\+}/g, '<i class="fal fa-genderless"></i>')
        text = text.replace(/\.\+/g, '. <i class="fal fa-genderless"></i>')
        text = text.replace(/\+/g, '<i class="fal fa-genderless"></i>')
        text = text.replace(/\.{>}/g, '. <i class="fal fa-angle-double-right"></i>')
        text = text.replace(/\{>}/g, '<i class="fal fa-angle-double-right"></i>')
        text = text.replace(/\{&gt;}/g, '<i class="fal fa-angle-double-right"></i>')
        text = text.replace(/\{<}/g, '<i class="fal fa-angle-double-left"></i>')
        text = text.replace(/\{&lt;}/g, '<i class="fal fa-angle-double-left"></i>')
        text = text.replace(/ >/g, ' <i class="fal fa-angle-double-right"></i>')
        text = text.replace(/\. >/g, '. <i class="fal fa-angle-double-right"></i>')
        text = text.replace(/&gt;/g, '<i class="fal fa-angle-double-right"></i>')
        text = text.replace(/ &gt;/g, ' <i class="fal fa-angle-double-right"></i>')
        text = text.replace(/&lt;/g, '<i class="fal fa-angle-double-left"></i>')
        text = text.replace(/><\/i><i/g, '></i> <i')
        return text
      },
    },
    mounted () {
      let $vue = this
      $(document).on('click', '.remove-grape', function () {
        $vue.removeGrapeFromList($(this).data('id'))
        return false
      })
    }
  };
</script>

<style>
  .theme-grapevine .vdatetime-popup__header,
  .theme-grapevine .vdatetime-calendar__month__day--selected > span > span,
  .theme-grapevine .vdatetime-calendar__month__day--selected:hover > span > span {
    background: #36a731;
  }

  .theme-grapevine .vdatetime-year-picker__item--selected,
  .theme-grapevine .vdatetime-time-picker__item--selected,
  .theme-grapevine .vdatetime-popup__actions__button {
    color: #36a731;
  }
  .input-field {
    position: relative;
    margin-bottom: 20px;
  }
  .list-wrap {
    text-align: left;
    max-width: 90%;
    margin: 0 auto 100px;
  }
  .list-wrap .pure-form {
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #ececec;
  }
  .list-wrap .pure-form label {
    font-weight: bold;
    line-height: 30px
  }
  .list-wrap .pure-form select, .list-wrap .pure-form input {
    width: 100%;
  }
  .list-wrap .pure-form .vdatetime-input {
    width: 250px;
  }
  .list-wrap form input[type="search"] {
    line-height: 30px;
    width: 100%;
    margin-bottom: 10px;
    box-sizing: border-box;
  }
  .list-actions {
    padding-right: 20px;
    box-sizing: border-box;
  }
  .list-actions h4 {
    border-bottom: 1px solid #2c3e50;
    padding: 0 0 4px;
    margin: 30px 0 20px;
    line-height: 30px;
  }

  #share-screenshot img {
    max-width: 720px;
  }
  #grape-capture-wrap {
    line-height: 1.4;
    width: 725px;
  }
  .grape-capture-outer {
    padding: 3px 2px 2px 2px;
    max-width: 720px;
    width: 725px;
  }
  .grape-capture {
    padding: 40px 60px;
    box-sizing: border-box;
    clear: both;
    height: auto;
    overflow: hidden;
    border: 5px solid #169a16;
    text-align: center;
    margin-left: 1px;
  }
  .grape-capture p {
    margin-top: 0;
    margin-bottom: 0;
    text-indent: 50px;
  }
  .grape-capture p i {
    text-indent: 1px;
  }
  .grape-capture p:first-child {
    text-indent: 0;
  }
  .grape-capture br {
    display: none;
  }
  .grape-capture .grape-source {
    margin-bottom: 5px;
    font-size: 1.1em;
    color: #169a16;
    font-style: italic;
    text-decoration: none;
    display: inline-block;
    padding: 15px 40px;
    max-width: 80%;
    margin: 0 auto 30px;
    border-top: 1px solid #eaeaea;
    border-bottom: 1px solid #eaeaea;
  }
  .grape-capture h4.grape-author {
    text-transform: uppercase;
    font-size: 1.4em;
    font-weight: 400;
    color: #169a16;
    margin: 0 0 10px;
    padding-top: 20px;
  }
  .grape-capture h3.grape-title {
    margin-top: .8em;
    font-size: 1.2em;
    margin-bottom: 20px;
  }
  .grape-capture .grape-center-divide {
    height: 1px;
    width: 50%;
    background: #eee;
    margin-bottom: 30px;
  }
  .grape-capture .grape-content-wrap {
    text-align: left;
    font-size: 1.05em;
  }
  .grape-capture .grape-content-preview-overlay {
    z-index: 1;
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    display: none;
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&0+0,1+100 */
    /* IE9 SVG, needs conditional override of 'filter' to 'none' */
    background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2ZmZmZmZiIgc3RvcC1vcGFjaXR5PSIwIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNmZmZmZmYiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+);
    background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%); /* FF3.6-15 */
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(255,255,255,0)), color-stop(100%,rgba(255,255,255,1))); /* Chrome4-9,Safari4-5 */
    background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* Chrome10-25,Safari5.1-6 */
    background: -o-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* Opera 11.10-11.50 */
    background: -ms-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* IE10 preview */
    background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 ); /* IE6-8 */
  }
  .grape-capture .grapevine-link a {
    display: inline-block;
    border-top: 1px solid #eaeaea;
    margin: 30px auto 10px;
    padding: 20px 50px;
    color: #169a16;
    text-decoration: none;
    font-weight: 800;
    font-size: 1.1em;
  }
</style>


// WEBPACK FOOTER //
// src/components/admin/twitterAdmin.vue